import { useTranslation } from "react-i18next";
import { Gender } from "src/core/backend/clients/backendClient";
import { useSettingsStore } from "src/features/settings/services/useSettingsStore";

export function useProfile() {
  const { t } = useTranslation();
  const settingsStore = useSettingsStore();

  const genderOptions = [
    {
      key: "gender1",
      label: t("Home.Registration.GenderMale"),
      value: Gender.Male,
    },
    {
      key: "gender2",
      label: t("Home.Registration.GenderFemale"),
      value: Gender.Female,
    },
  ];

  const birthDateLabel =
    t("Home.Registration.BirthDate") +
    (settingsStore.legacySettings.birthDateRequired ? " *" : "");

  const birthDateMin: Date = new Date(1900, 0, 1);
  const birthDateMax: Date = new Date();

  const ssnLabel =
    t("Home.Registration.SSN") +
    (settingsStore.legacySettings.ssnRequired ? " *" : "");

  const ssnMask: string = "999-999-999";

  const addressLabel =
    t("Home.Registration.Address") +
    (settingsStore.legacySettings.addressRequired ? " *" : "");

  const phoneLabel =
    t("Home.Registration.Phone") +
    (settingsStore.legacySettings.phoneRequired ? " *" : "");

  const phoneMask: string = "+(99) 99 999 9999";

  return {
    genderOptions,
    birthDateLabel,
    birthDateMin,
    birthDateMax,
    ssnLabel,
    ssnMask,
    addressLabel,
    phoneLabel,
    phoneMask,
  };
}
